import React from 'react'
import classNames from 'classnames'

import './Control.scss'

export interface ControlProps {
	label?: string
	errorMessage?: string
	isInColumn?: boolean
	isRequired?: boolean
	size?: SizeType
	disabled?: boolean
}

export interface ControlParts {
	labelElement: React.ReactElement | null
	helpTextElement: React.ReactElement | null
	inputId: string
}

export function getControlParts(props: ControlProps): ControlParts {
	let inputId = `input-${makeHtmlSafeId(props.label || '')}`

	let labelElement: React.ReactElement | null = null
	if (props.label) {
		let asterisk = props.isRequired ? <span className='asterisk has-text-danger'> ✱ </span> : null
		labelElement = 
			<label htmlFor={inputId} className='label'>{props.label} {asterisk}</label>
	}

	let helpTextElement: React.ReactElement | null = null
	if (props.errorMessage) {
		helpTextElement = <p className='help is-danger'>{props.errorMessage}</p>
	}

	return { inputId, labelElement, helpTextElement }
}

// only supported for inputs and selects for now (and not their labels either), for menu admin
export type SizeType = 'small' | 'normal' | 'medium' | 'large'

export type ColorType = 'primary' | 'link' | 'info' | 'success' | 'warning' | 'danger'

export type FloatType = 'left' | 'right'


// TODO: expand on this function if necessary to make more robust and complete
export function makeHtmlSafeId(text: string) {
	return text.toLowerCase().replaceAll(' ', '_')
}